import { FC, PropsWithChildren } from 'react';
import { ModalProps } from 'antd';

import ModalStyled, { ButtonStyled } from './styles';

type ButtonProps = {
  text?: string;
  onClick?: () => void;
};

type Props = PropsWithChildren<
  ModalProps & {
    cancelButton?: ButtonProps;
    okButton?: ButtonProps;
    loading?: boolean;
  }
>;

const Modal: FC<Props> = ({ cancelButton, okButton, children, loading = false, ...props }) => {
  return (
    <ModalStyled
      centered
      footer={[
        cancelButton ? (
          <ButtonStyled
            className="button-secondary"
            key="button-cancel"
            onClick={cancelButton.onClick}
          >
            <span className="button-label">{cancelButton.text}</span>
          </ButtonStyled>
        ) : null,
        okButton ? (
          <ButtonStyled
            className="button-primary"
            disabled={!!loading}
            key="button-ok"
            onClick={okButton.onClick}
          >
            <span className="button-label">{okButton.text}</span>
          </ButtonStyled>
        ) : null,
      ]}
      {...props}
      closable={false}
    >
      {children}
    </ModalStyled>
  );
};

export default Modal;
